import React from 'react';
import { useTranslation } from 'react-i18next';
import ComingSoon from './ComingSoon';

const CompanyData = () => {
  const { t } = useTranslation();
  return <ComingSoon title={t('settings.menu.companyData')} />;
};

export default CompanyData;
